import { cn } from '../lib/cn';

/**
 * AntiClaimBlock — typographic stanza of what SICA is not doing.
 *
 * Per ADR-006 §4.6: "No es card. Es estrofa tipográfica. Nunca decorado con
 * iconos." Used in marketing surfaces only (`@sica/site`); not displayed in
 * tool surfaces (`@sica/web`) per visual-identity.md §11.6.
 */
export function AntiClaimBlock({
  items,
  className,
}: {
  items: ReadonlyArray<string>;
  className?: string;
}) {
  return (
    <ul className={cn('anti-claim-list', className)}>
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}
